import { useEffect, useRef, useState } from 'react'
import { Button, Stack, } from '@mui/material'
import { Item } from './snippets'
import { Box, useTheme } from '@mui/system'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { focusElemnt, getLocalData, isEmpty, } from './helper'
import { useAtom } from 'jotai'
import { divideInNIntegers, withPxWidths } from './mathHelper'
import { exportToExcel } from './hook'
import { CargoRoleRightsAtom, fetchCargoRoleRightsAtomAtom } from './jotaiState/commonStateAtoms'
import { xlCol } from './constants'
import useToken from '../helpers/useTokens'
import { makeTable } from '../content/Reports/analysisReport/pdfAutotable'
import { lrDetailPdfFooter } from '../content/AcountingReport/common/AcountingConstants'
import AppsIcon from '@mui/icons-material/Apps'
import ManageColumns from './ManageColumnsUI'
import { modalAtom } from './jotaiState/globalStateAtoms'
import { callAddFontRobotoBold } from './font/Roboto-bold'
import { callAddFontRobotoMedium } from './font/Roboto-Medium-normal'
import SearchFilter from './SearchFilter'
import MuiltRenderTable from './MuiltRenderTable'
import { syncColumnsWithDefaults } from '../content/Reports/common/reportContainsFilter'

const currentDateTime = moment(new Date()).format('DD-MMM-YYYY HH:mm')

export const MultiTableComponent = (props) => {
    const theme = useTheme()
    const [modal, setModal] = useAtom(modalAtom)
    const { tableHeaderColor } = theme

    const {
        tables = [], // [{ mainHeader, tableData, excelTableData, criteriaHeaders, criteriaData, reportName }]
        reportName = '',
        hideControls = false,
        hideHeader = false,
        isShowPdfPrint = true,
        isShowManageColumn = false,
        manageColumnID,
        showColumnBorders = false,
        isIncreFontSize = false,
        pdfFontSize = 1,
        isClampHeaderToTwoLines = false,
        isWrapEntryText = false,
        enableHorizontalScroll = false,
        minTableWidth,
        fitCriteriaToPage = false,
    } = props
    const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
    const [, getRoleRights] = useAtom(fetchCargoRoleRightsAtomAtom)
    const { loginData } = useToken()
    const roleRightsFetchAttempted = useRef(false)
    useEffect(() => {
      if (roleRightsFetchAttempted.current || cargoRoleRights?.Table1?.length || !loginData?.intUserID) return
      roleRightsFetchAttempted.current = true
      getRoleRights({
        intRoleID: loginData.intRoleID,
        intUserID: loginData.intUserID,
      })
    }, [cargoRoleRights, loginData?.intRoleID, loginData?.intUserID, getRoleRights])
    const { Table1: RoleRightTable1 = [] } = isEmpty(cargoRoleRights) ? {} : cargoRoleRights
    const [roleRightsData] = RoleRightTable1
    const { AllowExportExcel = 1, AllowPrintandPdf = 0 } = { ...roleRightsData }
    const [searchResult, setSearchResult] = useState(true)
    // ---------------- Manage Column (ONLY FIRST TABLE) ----------------
    const [manageColumn, setManageColumn] = useState([])
    const [columns, setColumns] = useState([])
    const [matches, setMatches] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [processedTables, setProcessedTables] = useState([])
    const [sortedTableDataByIndex, setSortedTableDataByIndex] = useState({})

    const visibleColumns = columns.length ? columns : tables[0]?.mainHeader
    const setColumn = async () => {
        const savedColumns = await getLocalData(manageColumnID)
        const mainHeader = tables[0]?.mainHeader || []
        let defaultColumns = syncColumnsWithDefaults(savedColumns, mainHeader)
        setManageColumn(defaultColumns)
        if (isShowManageColumn) {
            setColumns(defaultColumns.filter((col) => col.isSelected === true))
        } else {
            setColumns(mainHeader)
        }
    }
    useEffect(() => {
        setColumn()
    }, [manageColumnID, tables])
    const getColumns = (tbl, index) => {
        return index === 0 ? (columns.length ? columns : tbl.mainHeader) : tbl.mainHeader
    }

    useEffect(() => {
        if (!tables?.length) {
            setProcessedTables(tables)
            return
        }

        const updatedTables = tables.map((tbl, idx) => {
            const cols = getColumns(tbl, idx)

            if (!tbl.totalSubKey && !tbl.colSpanMarker) {
                return { ...tbl, tableData: tbl.tableData }
            }

            const headerLengths = tbl.totalSubKey
                ? divideInNIntegers(cols.length, tbl.totalSubKey)
                : []
            const pickedHeadersList = []
            let index = 0

            headerLengths.forEach((span) => {
                pickedHeadersList.push(cols[index]?.field)
                index += span
            })

            const markerIndex = tbl.colSpanMarker
                ? cols.findIndex((col) => col.field === tbl.colSpanMarker)
                : -1

            const updatedData = tbl.tableData.map((row) => {
                if (row.dataType === 'subHeader' && row.totalSubKey) {
                    const subKeyValue = Object.keys(row)
                        .filter((key) => !['dataType', 'align', 'colSpan', 'totalSubKey'].includes(key))
                        .map((key) => row[key] || '')

                    const newObj = {}
                    const colspanObj = {}
                    const alignObj = {}

                    pickedHeadersList.forEach((key, index) => {
                        newObj[key] = subKeyValue[index] ?? ''
                        colspanObj[key] = headerLengths[index]
                        alignObj[key] =
                            index === pickedHeadersList.length - 1
                                ? 'right'
                                : index === 0
                                    ? 'left'
                                    : 'center'
                    })

                    return {
                        ...newObj,
                        dataType: row.dataType,
                        align: alignObj,
                        colSpan: colspanObj,
                        totalSubKey: row.totalSubKey,
                    }
                }

                if (row?.dataType === 'total' && row?.colSpan && markerIndex !== -1) {
                    const firstField = Object.keys(row.colSpan)[0]
                    const span = markerIndex + 1

                    return {
                        ...row,
                        colSpan: {
                            ...row.colSpan,
                            [firstField]: span,
                        },
                    }
                }

                return row
            })

            return {
                ...tbl,
                tableData: updatedData,
            }
        })

        setProcessedTables(updatedTables)
    }, [tables, columns])

    const renderedTables = processedTables.length ? processedTables : tables

    const handleSortedDataChange = (idx, data) => {
        setSortedTableDataByIndex((prev) => {
            if (prev[idx] === data) return prev
            return { ...prev, [idx]: data }
        })
    }

    const getSortedTableData = (tbl, idx) => (tbl.defaultSortConfig ? (sortedTableDataByIndex[idx] || tbl.tableData) : tbl.tableData)

    const getExportTableData = (tbl, idx) => {
        if (tbl.excelTableData?.length) return tbl.excelTableData
        return getSortedTableData(tbl, idx)
    }

    const searchTables = renderedTables.map((tbl, idx) => ({
        id: idx, // or tbl.id if exists
        data: tbl.tableData,
        columnDefs: getColumns(tbl, idx),
        totalColDef: tbl.totalColDef || []
    }));
    const prepareExcel = () => {
        const sourceTables = processedTables.length ? processedTables : tables;
        const headersList = [];
        const dataList = [];
        headersList.push([
            { field: 'reportName', header: `Report Name: ${reportName}` },
            { field: 'companyName', header: `Company Name: ${loginData?.strCompanyName || ''}` }
        ]);
        dataList.push([{}]);
        const firstTable = sourceTables[0];
        if (firstTable?.criteriaData?.length) {
            headersList.push(firstTable.criteriaHeaders || []);
            dataList.push(firstTable.criteriaData || []);
        }
        sourceTables.forEach((tbl, idx) => {
            const cols = getColumns(tbl, idx);
            const mainHeaders = cols.map(col => ({
                field: col.field,
                header: col.exportHead?.replace(/\n/g, ' '),
                textAlign: col.align,
                isExcelLink: col.isExcelLink,
                link: col.link
            }));

            if (tbl.summaryFields?.length) {
                const sectionField = tbl.summaryFields.find((item) => item.isSection)
                const detailSummaryFields = tbl.summaryFields.filter((item) => !item.isSection)
                const leftSummaryFields = detailSummaryFields.filter((_, index) => index % 2 === 0)
                const rightSummaryFields = detailSummaryFields.filter((_, index) => index % 2 !== 0)
                const summaryExcelData = []
                const firstField = mainHeaders[0]?.field
                const rightStartIndex = Math.max(1, Math.ceil(mainHeaders.length / 2))
                const rightFieldKey = mainHeaders[rightStartIndex]?.field || mainHeaders[mainHeaders.length - 1]?.field
                const leftSpan = rightStartIndex
                const rightSpan = Math.max(1, mainHeaders.length - rightStartIndex)

                if (sectionField?.value && firstField) {
                    summaryExcelData.push({
                        [firstField]: sectionField.value,
                        dataType: 'entry',
                        colSpan: {
                            [firstField]: mainHeaders.length,
                        },
                        align: {
                            [firstField]: 'left',
                        },
                    })
                }

                for (let index = 0; index < Math.max(leftSummaryFields.length, rightSummaryFields.length); index += 1) {
                    const leftSummaryItem = leftSummaryFields[index]
                    const rightSummaryItem = rightSummaryFields[index]
                    const rowData = {
                        dataType: 'entry',
                        colSpan: {},
                        align: {},
                    }

                    if (leftSummaryItem && firstField) {
                        rowData[firstField] = `${leftSummaryItem.label} : ${leftSummaryItem.value}`
                        rowData.colSpan[firstField] = leftSpan
                        rowData.align[firstField] = 'left'
                    }

                    if (rightSummaryItem && rightFieldKey) {
                        rowData[rightFieldKey] = `${rightSummaryItem.label} : ${rightSummaryItem.value}`
                        rowData.colSpan[rightFieldKey] = rightSpan
                        rowData.align[rightFieldKey] = 'right'
                    }

                    summaryExcelData.push({
                        ...rowData,
                    })
                }

                headersList.push(mainHeaders.map((item, headerIndex) => ({
                    ...item,
                    hideHeader: true,
                    header: '',
                })))
                dataList.push(summaryExcelData)
            }
            headersList.push(tbl.hideHeader
                ? mainHeaders.map((item) => ({ ...item, hideHeader: true }))
                : mainHeaders);
            dataList.push(getExportTableData(tbl, idx));
        });

        return { headersList, dataList };
    };
    const printClick = (isSave) => {
        const sourceTables = processedTables.length ? processedTables : tables;
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold]);
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium]);

        const orientation = visibleColumns.length > 14 ? 'l' : 'p';
        const format = orientation === 'l' ? [1810, 1280] : [1280, 1810];
        let totalPagesExp = '{total_pages_count_string}';

        const doc = new jsPDF({ orientation, format, unit: 'px', compress: true });

        doc.setProperties({
            title: `${reportName}.pdf`,
            subject: `${reportName}`,
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        });

        const pageTop = 120;
        const didDrawPage = (data) => {
            // HEADER
            doc.setTextColor(40);
            doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50);
            doc.setFontSize(26).setFont('Roboto', 'bold');
            doc.setTextColor(16, 79, 162);
            doc.text(`Cargo System | ${reportName}`, 90, 80);
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(22).setFont('Roboto', 'bold');
            doc.text(
                `Company Name :${loginData.strCompanyName}`,
                doc.internal.pageSize.width - data.settings.margin.left,
                80,
                'right'
            );
            lrDetailPdfFooter(data, loginData, totalPagesExp);
        };

        let startY = pageTop;

        sourceTables.forEach((tbl, idx) => {
            if (idx === 0 && tbl.criteriaData?.length) {
                const criteriaCols = tbl.criteriaHeaders || [];
                const headerColumns = (fitCriteriaToPage
                    ? withPxWidths(
                        criteriaCols.map((col) => ({ ...col, weight: col.weight ?? 80 })),
                        format[0] - 60
                    )
                    : criteriaCols
                ).map((col) => ({
                    header: col.header,
                    dataKey: col.field,
                    xlCol: col.xlCol || xlCol,
                    ...(col.width ? { width: col.width } : {}),
                }));

                makeTable(
                    doc,
                    autoTable,
                    headerColumns,
                    tbl.criteriaData || [],
                    pdfFontSize,
                    tbl.reportName || reportName,
                    loginData,
                    'everyPage',
                    didDrawPage,
                    startY,
                    false,
                    false,
                    false,
                    { isIncreFontSize }
                );
                startY = doc.lastAutoTable.finalY + 10;
            }

            // Main tables
            const visibleCols = getColumns(tbl, idx);
            const pdfColumns = withPxWidths(visibleCols, format[0] - 60).map((col) => ({
                header: col.exportHead,
                dataKey: col.field,
                xlCol: col.xlCol,
                width: col.width || 0,
            }));

            // Print table name above main table
            if (tbl.reportName) {
                autoTable(doc, {
                    margin: { left: 30, right: 30, bottom: 0 },
                    startY: doc.lastAutoTable.finalY + 14,
                    theme: 'plain',
                    head: [],
                    body: [[tbl.reportName]],
                    bodyStyles: {
                        minCellHeight: 35,
                        valign: 'middle',
                        font: 'Roboto',
                        fontStyle: 'bold',
                        fontSize: 16,
                        halign: 'left',

                    },
                    didParseCell: function (data) {

                    }
                })
                startY = doc.lastAutoTable.finalY;
            }

            if (tbl.summaryFields?.length) {
                const sectionField = tbl.summaryFields.find((item) => item.isSection)
                const detailSummaryFields = tbl.summaryFields.filter((item) => !item.isSection)
                const leftSummaryFields = detailSummaryFields.filter((_, index) => index % 2 === 0)
                const rightSummaryFields = detailSummaryFields.filter((_, index) => index % 2 !== 0)
                const summaryBody = []

                if (sectionField) {
                    summaryBody.push([sectionField.value || '', ''])
                }

                for (let index = 0; index < Math.max(leftSummaryFields.length, rightSummaryFields.length); index += 1) {
                    const leftField = leftSummaryFields[index]
                    const rightField = rightSummaryFields[index]
                    summaryBody.push([
                        `${leftField?.label || ''} : ${leftField?.value || ''}`,
                        `${rightField?.label || ''} : ${rightField?.value || ''}`,
                    ])
                }

                autoTable(doc, {
                    margin: { left: 30, right: 30, bottom: 0 },
                    startY: startY + 4,
                    theme: 'plain',
                    body: summaryBody,
                    styles: {
                        minCellHeight: 20,
                        font: 'Roboto',
                        fontStyle: 'bold',
                        fontSize: 12,
                        cellPadding: 0,
                        textColor: [68, 68, 68],
                    },
                    columnStyles: {
                        0: { halign: 'left', cellWidth: 'wrap' },
                        1: { halign: 'right', cellWidth: 'wrap' },
                    },
                    didParseCell: (data) => {
                        if (sectionField && data.row.index === 0) {
                            if (data.column.index === 0) {
                                data.cell.styles.fontStyle = 'bold'
                            } else {
                                data.cell.text = ['']
                            }
                        }
                    },
                })
                startY = doc.lastAutoTable.finalY + 6
            }

            makeTable(
                doc,
                autoTable,
                pdfColumns,
                getSortedTableData(tbl, idx),
                pdfFontSize,
                tbl.reportName || reportName,
                loginData,
                (tbl.hideHeader ?? hideHeader) ? 'never' : 'everyPage',
                didDrawPage,
                startY,
                false,
                true,
                showColumnBorders,
                {
                    isIncreFontSize: tbl.isIncreFontSize ?? isIncreFontSize,
                    enableTextColor: tbl.enableTextColor
                }
            );
            startY = doc.lastAutoTable.finalY + 10;
        });

        doc.setFont('Roboto');
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }
        if (isSave) {
            doc.save(`${reportName} ${currentDateTime}.pdf`);
        }
        setTimeout(() => {
            const pdfUrl = doc.output('bloburl');
            document.getElementById('multiPdf').data = pdfUrl;
            focusElemnt('backBtn');
        }, 1000);
    };



    const onSaveColumns = (items) => {
        setManageColumn(items)
        setColumns(items.filter((col) => col.isSelected))
        localStorage.setItem(manageColumnID, JSON.stringify(items))
    }

    return (
        <>
            <SearchFilter
                tables={searchTables}
                matches={matches}
                setMatches={setMatches}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
            />
            <Stack style={{ margin: '10px' }}>
                <Item
                    className="userReport"
                    style={{ padding: 0, display: hideControls ? 'none' : 'flex' }}
                >
                    <Item
                        className="userReport-heading"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                    >
                        Report For: {reportName}

                        {isShowManageColumn && (
                            <Box
                                style={{
                                    height: '32px',
                                    display: 'flex',
                                    padding: '8px 12px',
                                    gap: '6px',
                                }}
                                id="dispatchReportManageColumn"
                                tabIndex={0}
                                onClick={() => setModal('ShowManageColumn')}
                            >
                                <span style={{ display: 'flex', margin: '-3px' }}>
                                    <AppsIcon />
                                </span>
                                <span style={{ fontWeight: 'bold' }}>
                                    MANAGE COLUMNS
                                </span>
                            </Box>
                        )}
                    </Item>

                    <Item className="userReport-buttons" style={{ paddingRight: 0 }}>
                        {searchResult ? (
                            <>
                                <Box>
                                    <Button
                                        variant="outlined"
                                        className="userWisereporttembtn"
                                        disabled={!AllowExportExcel}
                                        onClick={() => {
                                            const { headersList, dataList } = prepareExcel();
                                            exportToExcel({
                                                fileName: `${reportName} ${currentDateTime}.xlsx`,
                                                sheetName: reportName,
                                                headersList,
                                                dataList,
                                            });
                                        }}
                                    >
                                        Export to Excel
                                    </Button>
                                </Box>

                                {isShowPdfPrint && (
                                    <>
                                        <Box>
                                            <Button
                                                variant="outlined"
                                                className="userWisereporttembtn"
                                                onClick={() => {
                                                    setSearchResult(false)
                                                    printClick(true)
                                                }}
                                                disabled={!AllowPrintandPdf}
                                            >
                                                Export to Pdf
                                            </Button>
                                        </Box>

                                        <Box>
                                            <Button
                                                variant="outlined"
                                                className="userWisereporttembtn"
                                                onClick={() => {
                                                    setSearchResult(false)
                                                    printClick(false)
                                                }}
                                                disabled={!AllowPrintandPdf}
                                            >
                                                Print
                                            </Button>
                                        </Box>
                                    </>
                                )}
                            </>
                        ) : (
                            <Box>
                                <Button
                                    id="backBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => setSearchResult(true)}
                                >
                                    Back
                                </Button>
                            </Box>
                        )}
                    </Item>
                </Item>
            </Stack>
            <Stack>
                {searchResult ? (
                    renderedTables.map((tbl, idx) => {
                        const cols = getColumns(tbl, idx)
                        return (
                            <MuiltRenderTable
                                key={idx}
                                idx={idx}
                                hideHeader={tbl.hideHeader ?? hideHeader}
                                tableData={tbl.tableData}
                                reportName={tbl.reportName}
                                summaryFields={tbl.summaryFields}
                                matches={matches}
                                currentIndex={currentIndex}
                                serialNokey={tbl.serialNokey}
                                tableHeaderColor={tableHeaderColor}
                                cols={cols}
                                isInvoiceRedirect={tbl.isInvoiceRedirect || false}
                                showColumnBorders={showColumnBorders}
                                isIncreFontSize={tbl.isIncreFontSize ?? isIncreFontSize}
                                isClampHeaderToTwoLines={tbl.isClampHeaderToTwoLines ?? isClampHeaderToTwoLines}
                                isWrapEntryText={tbl.isWrapEntryText ?? isWrapEntryText}
                                enableHorizontalScroll={tbl.enableHorizontalScroll ?? enableHorizontalScroll}
                                minTableWidth={tbl.minTableWidth ?? minTableWidth}
                                defaultSortConfig={tbl.defaultSortConfig}
                                onSortedDataChange={(data) => handleSortedDataChange(idx, data)}
                            />

                        )
                    })
                ) : (
                    <object id="multiPdf" type="application/pdf" width="100%"
                        height={`${window.innerHeight - 100}px`}
                    />
                )}
            </Stack>

            {modal === 'ShowManageColumn' && (
                <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={setModal} />
            )}
        </>
    )
}
